import { useSelector } from "@jti/store/reduxHooks";
import { type RootStoreState } from "@jti/store/types";
import { replaceStringPlaceholder } from "@jti/ui/utils/replaceStringPlaceholder";

const useStringPlaceholder = () => {
  const {
    name,
    points: { balance },
    rewards,
  } = useSelector((state: RootStoreState) => state.loyaltyCore);
  const placeholdersConfig = [
    {
      placeholder: "userName",
      value: name,
    },
    {
      placeholder: "userPoints",
      value: balance,
    },
    {
      placeholder: "rewardsNumber",
      value: rewards,
    },
  ];

  return (text: string, withStyle?: boolean) => replaceStringPlaceholder(text, placeholdersConfig, withStyle);
};

export default useStringPlaceholder;
